import { useMemo } from 'react'
import './PaymentMethodSelector.css'

function PaymentMethodReceipt({ payment, adjustmentAmount, theme, formatCurrency }) {
  const styles = useMemo(() => {
    const next = {}
    if (theme?.accent) next['--pm-accent'] = theme.accent
    if (theme?.accentSoft) next['--pm-accent-soft'] = theme.accentSoft
    if (theme?.text) next['--pm-text'] = theme.text
    if (theme?.muted) next['--pm-muted'] = theme.muted
    if (theme?.border) next['--pm-border'] = theme.border
    if (theme?.surface) next['--pm-surface'] = theme.surface
    if (theme?.surfaceMuted) next['--pm-surface-muted'] = theme.surfaceMuted
    return next
  }, [theme])

  const paymentIcon = (type) => {
    if (type === 'cash') return 'payments'
    if (type === 'bank_transfer') return 'account_balance'
    if (type === 'postnet') return 'credit_card'
    if (type === 'gateway_mercadopago') return 'shoppingmode'
    return 'credit_card'
  }

  const label = payment?.label || 'Pendiente'
  const type = payment?.type || null
  const hasAdjustment = Number.isFinite(adjustmentAmount) && adjustmentAmount !== 0
  const formattedAdj = typeof formatCurrency === 'function' ? formatCurrency(Math.abs(adjustmentAmount)) : String(Math.abs(adjustmentAmount))
  const badgeText = hasAdjustment ? `${adjustmentAmount < 0 ? 'Descuento' : 'Recargo'} ${adjustmentAmount < 0 ? '-' : '+'}${formattedAdj}` : null

  return (
    <div className="payment-method-selector" style={styles}>
      <div className="pm-card" data-active="true">
        <div className="pm-card-button" style={{ cursor: 'default' }}>
          <div className="pm-radio" />
          <div style={{ flex: 1, minWidth: 0 }}>
            <div className="pm-header">
              <div style={{ display: 'flex', gap: 10, minWidth: 0, alignItems: 'flex-start' }}>
                <span className="material-symbols-outlined" style={{ color: 'var(--pm-accent)', fontSize: 22, lineHeight: 1 }}>
                  {paymentIcon(type)}
                </span>
                <div style={{ minWidth: 0 }}>
                  <div className="pm-title">{label}</div>
                  <div className="pm-subtitle">Medio de pago</div>
                </div>
              </div>
              {badgeText ? (
                <span className={`pm-badge ${adjustmentAmount < 0 ? 'pm-badge-discount' : 'pm-badge-surcharge'}`}>
                  {badgeText}
                </span>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PaymentMethodReceipt

